// MUST be first: polyfills ES2015+ runtime methods for old browsers. Air-gapped
// OT workstations can be stuck on ancient Chrome (e.g. 78), where an un-polyfilled
// method throws and silently kills a click handler (the acknowledge buttons).
import 'react-app-polyfill/stable';

import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts.css';
import './utils/axiosConfig';
import App from './App';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
